// ==================== 内容安全过滤模块 ====================
// 基于本地敏感词列表进行内容审核，无需外部 API。

import type { ContentCheckResult } from '#/index'

const SENSITIVE_WORDS: string[] = ['敏感词1', '敏感词2', '敏感词3']

/**
 * 检查文本是否包含敏感词
 * @param text - 用户输入文本
 * @returns 审核结果
 */
export function checkContent(text: string): ContentCheckResult {
  const lowerText = text.toLowerCase()
  for (const word of SENSITIVE_WORDS) {
    if (lowerText.includes(word.toLowerCase())) {
      return { passed: false, reason: 'CONTENT_REVIEW_FAIL' }
    }
  }
  return { passed: true }
}
